module.exports = __webpack_public_path__ + "img/menu-white.6617b1c9.svg";